import { TextField, Typography, Stack } from "@mui/material";
import { User } from "../../../../types/User";

interface JobTitleProps {
    userData: User;
    handleChange: (field: string, value: any) => void;
    editMode: boolean;
}

const JobTitle = ({ userData, handleChange, editMode }: JobTitleProps) => {
    return (
        <Stack gap={2} sx={{ mb: 2 }}>
            {editMode ? (
                <TextField
                    fullWidth
                    size="small"
                    label="Job Title"
                    value={userData.jobTitle || ""}
                    onChange={(e) => handleChange("jobTitle", e.target.value)}
                />
            ) : (
                <Typography variant="h5">
                    {userData.jobTitle || "Job Title not set yet"}
                </Typography>
            )}

            {editMode ? (
                <TextField
                    fullWidth
                    size="small"
                    placeholder="Describe your job responsibilities and year of experience"
                    label="Job Description"
                    multiline
                    minRows={4}
                    value={userData.jobDescription || ""}
                    onChange={(e) => handleChange("jobDescription", e.target.value)}
                />
            ) : (
                <Typography variant="subtitle2" color="text.secondary" fontWeight="light">
                    {userData.jobDescription || "Job Description not set yet"}
                </Typography>
            )}
        </Stack>
    );
};

export default JobTitle; 